var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLateProtectionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 510,
    viewBox: "0 0 514 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M502.445 380.24H237.322C210.757 380.24 189.234 358.704 189.234 332.152C189.234 305.588 210.769 284.053 237.322 284.053H502.445C508.298 284.053 513.036 288.791 513.036 294.645V369.648C513.036 375.501 508.298 380.24 502.445 380.24ZM237.322 363.067C254.397 363.067 268.237 349.228 268.237 332.152C268.237 315.077 254.397 301.237 237.322 301.237C220.246 301.237 206.407 315.077 206.407 332.152C206.407 349.228 220.246 363.067 237.322 363.067Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M442.724 121.188H394.297V86.8438H399.266C420.389 86.8438 438.07 101.495 442.724 121.188Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.48 332.152C175.48 366.303 203.159 393.982 237.31 393.982H496.156V464.381C496.156 489.054 476.16 509.05 451.498 509.05H44.6578C19.996 509.05 0 489.054 0 464.381V131.502C0 106.84 19.996 86.8438 44.6578 86.8438H54.0256V121.188H49.9416C41.3372 121.188 34.3568 128.169 34.3568 136.773C34.3568 145.378 41.3372 152.37 49.9416 152.37H451.498C476.16 152.37 496.156 172.354 496.156 197.028V270.31H237.31C203.159 270.31 175.48 298.002 175.48 332.152Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M383.989 0V142.057H353.074V77.7057C350.372 78.2874 347.572 78.6025 344.688 78.6025C322.983 78.6025 305.387 61.006 305.387 39.3013C305.387 36.4291 305.69 33.6175 306.283 30.915H142.049C142.643 33.6175 142.946 36.4291 142.946 39.3013C142.946 61.006 125.35 78.6025 103.645 78.6025C100.761 78.6025 97.9613 78.2874 95.2588 77.7057V142.057H64.3438V0H383.989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLateProtectionWhite);
export default __webpack_public_path__ + "static/media/Logo_LateProtection_White.4bddce67c4363c91ebaa9d5ea9ecef65.svg";
export { ForwardRef as ReactComponent };